import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { TransportEquipmentDataGrid } from "src/components/views/erp/delivery/masterData/TransportEquipmentDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/delivery/transportEquipment")({
	staticData: { title: i18n.t("transport_equipment"), legacyViewKey: "transportEquipmentPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <TransportEquipmentDataGrid />;
}
